import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Input from '../../Input';
import Modal from '../../Modal';
import Button from '../../Button';
import Sortable from '../../Sortable';
import arrayMove from 'array-move';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Edit } from '../../../assets/svg/edit.svg';
import { ReactComponent as Add } from '../../../assets/svg/add.svg';

const LessonEditDataListOrder = ({ data = [], onChange = () => {} }) => {
  const [items, setItems] = useState(data);

  const [showModal, setShowModal] = useState(undefined);
  const [text, setText] = useState('');

  useEffect(() => {
    setItems(data);
  }, [data]);

  useEffect(() => {
    onChange({
      data: items,
    });
  }, [items, onChange]);

  const onSortEnd = ({ oldIndex, newIndex }) =>
    setItems((state) => arrayMove(state, oldIndex, newIndex));

  const onDelete = (index) =>
    setItems((items) => {
      const clone = [...items];
      clone.splice(index, 1);
      return clone;
    });

  const onAdd = () => {
    setText('');
    setShowModal({
      submit: 'Agregar',
      onSubmit: (text) => {
        setItems((items) => [...items, { text: text }]);
        setShowModal(undefined);
      },
    });
  };

  const onEdit = (index) => {
    setText(items[index].text);
    setShowModal({
      submit: 'Guardar',
      onSubmit: (text) => {
        setItems((items) => {
          const clone = [...items];
          clone[index] = { text: text };
          return clone;
        });
        setShowModal(undefined);
      },
    });
  };

  return (
    <Container>
      {showModal && (
        <ModalStyled>
          <ModalContainer>
            <ModalBody>
              <Input
                placeholder='Texto'
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
            </ModalBody>
            <ModalButtons>
              <Button
                secondary
                text='Cancelar'
                onClick={() => setShowModal(undefined)}
              />
              <Button
                primary
                text={showModal.submit}
                onClick={() => showModal.onSubmit(text)}
              />
            </ModalButtons>
          </ModalContainer>
        </ModalStyled>
      )}

      <Sortable
        items={items}
        render={(item, index) => (
          <Wrapper key={index}>
            <Text>{item.text}</Text>
            <Options>
              <OptionIcon
                as={Delete}
                color='#c62828'
                onClick={() => onDelete(index)}
              />
              <OptionIcon
                as={Edit}
                color='#1976d2'
                onClick={() => onEdit(index)}
              />
            </Options>
          </Wrapper>
        )}
        onSortEnd={onSortEnd}
      />
      <WrapperAdd onClick={onAdd}>
        <OptionIcon as={Add} color='#2196f3' />
      </WrapperAdd>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  padding: 15px 15px;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  user-select: none;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  background-color: #caedff;
  margin-bottom: 10px;
`;

const WrapperAdd = styled.div`
  border-radius: 10px;
  border: 2px dashed #2196f3;
  min-height: 50px;
  width: 100%;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
`;

const Text = styled.div`
  font-size: 0.9em;
`;

const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OptionIcon = styled.div`
  padding: 5px;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  cursor: pointer;
  fill: ${(props) => props.color || 'black'};
  :not(:last-child) {
    margin-right: 10px;
  }
`;

const ModalStyled = styled(Modal)`
  max-width: 400px;
  width: 100%;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const ModalBody = styled.div``;

const ModalButtons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > * {
    margin: 5px;
  }
  @media (max-width: 240px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export default LessonEditDataListOrder;
